import fr from 'facet-rest';
import PlaybookPredefinedTaskTitle from 'Components/UI/Overrides/PlaybookPredefinedTaskTitle';
import PlaybookPredefinedTasks from 'Components/UI/Overrides/PlaybookPredefinedTasks';

const PlaybookPredefinedTasksOverride = fr.metaOverride()
  .nameOverride('category', {
    readonly: false,
    _component: () => PlaybookPredefinedTaskTitle,
  })
  .nameOverride('tasks', {
    _component: () => PlaybookPredefinedTasks,
  });

export default PlaybookPredefinedTasksOverride;
